<template>
  <v-dialog v-model="dialog" width="500" :loading="isLoading" id="chatbot">
    <v-card>
      <v-card-title>
        <h2>Q&A</h2>
        <v-spacer />
        <v-btn
          small
          class="mr-2"
          outlined
          color="primary"
          @click="isRecording = true"
          :disabled="isRecording"
        >Speak</v-btn>
        <v-btn small outlined color="primary" @click="onClear">Clear</v-btn>
      </v-card-title>

      <v-card-text class="tile-content pb-0">
        <v-sheet height="300">
          <div style="height:100%; overflow-y: scroll;" ref="qa-container-answers">
            <ul class="qa-list" id="example-1">
              <li class="qa-item" v-for="(qaItem, index) in qaItems" :key="index">
                <p class="question">{{qaItem.question}}</p>
                <p class="answer" v-html="qaItem.answer" />
              </li>
            </ul>
          </div>
          <lex-bot :start="isRecording" @stopped="isRecording = false" adjust-user-id="-1" />
        </v-sheet>
      </v-card-text>
      <v-card-actions class="pb-0">
        <v-text-field
          placeholder="Enter a question and press [enter]"
          v-model="question"
          v-on:keyup.enter="send"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import Trimaster from "@/plugins/servers/trimaster.js";
import LexBot from "@/components/util/LexBot.vue";
import vuetifyToast from "@/vuetifyToast.js";

export default {
  name: "chat",
  components: {
    LexBot
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data() {
    return {
      message: "",
      isRecording: false,
      question: "",
      qaItems: [],
      isLoading: false,
      dialog: false
    };
  },
  computed: {
    ...mapGetters(["getUser"])
  },
  watch: {
    dialog(val) {
      if (!val) {
        return this.$emit("closed", val);
      }
    },
    show(val) {
      this.dialog = !!val;
      return this.onClear();
    }
  },
  methods: {
    startRecording() {
      this.isRecording = true;
    },
    onClear() {
      const vm = this;

      Trimaster.post(`lex_questions/clearAll`, vm.getUser.apitoken, {
        user_id: -1 * vm.getUser.id
      }).then(([res, err]) => {
        if (err) return vuetifyToast.error(err);

        //vuetifyToast.success(res)
        vm.refresh();
      });
    },
    send() {
      const vm = this;
      vm.isLoading = true;
      vm.message = "Submitting question to the cloud...";

      Trimaster.post(`lexbots/text`, vm.getUser.apitoken, {
        text: vm.question
      }).then(([res, err]) => {
        if (err) return vuetifyToast.error(err);

        let endpoint = res.intentName;

        // If a bad request then just show the message from the lex bot
        if (!endpoint || !endpoint.length) {
          return vm.saveQuestion(vm.question, res.message);
        }

        res.slots.facility_id = vm.getUser.facility_id;
        return Trimaster.post(`lexbots/${endpoint}`, vm.getUser.apitoken, {
          params: res.slots
        }).then(([res2, err2]) => {
          if (err2) return vm.saveQuestion(vm.question, err2);

          return vm.saveQuestion(vm.question, res2);
        });
      });
    },
    saveQuestion(question, answer) {
      const vm = this;

      Trimaster.post(`lex_questions`, vm.getUser.apitoken, {
        user_id: -1 * vm.getUser.id,
        question: question,
        answer: answer
      }).then(([res, err]) => {
        if (err) return vuetifyToast.error(err);

        vm.question = "";
        vm.refresh();
        vm.isLoading = false;
      });
    },
    refresh() {
      const vm = this;

      Trimaster.get(`lex_questions`, vm.getUser.apitoken, {
        filter: {
          where: {
            user_id: -1 * vm.getUser.id
          },
          // Not necessary but still...
          order: "id DESC",
          limit: 25
        }
      }).then(([res, err]) => {
        if (err) return vuetifyToast.error(err);
        res = res || [];

        vm.qaItems = res.reverse();

        setTimeout(() => {
          try {
            let cont = vm.$refs["qa-container-answers"];
            cont.scrollTop = cont.scrollHeight;
          } catch (err2) {}
        }, 50);
      });
    }
  },
  mounted() {
    const vm = this;
    vm.refresh();

    vm.$root.eventHub.$on("lex-bot-saved-question", () => {
      vm.refresh();
    });
  }
};
</script>

<style lang="scss">
#chatbot {
  .qa-list {
    list-style: none;
    padding-left: 0;
  }

  .question {
    font-weight: bold;
    display: block;
    margin-bottom: 0;
  }

  .qa-item {
    border-bottom: 1px solid lightgray;
    margin-bottom: 15px;
    padding-bottom: 10px;
  }
}
</style>